export default {
  common: {
    userName: '用户名',
    passWord: '密码',
    code: '验证码',
    forget: '忘记密码',
    platform: '平台对接',
    docking: '对接申请表',
    fire: '火知眼在线',
    app: '火知眼助手',
    firstLogin: '首次登录修改密码',
    loginName: '登录帐户',
    newPass: '新密码',
    confirmpass: '确认密码',
    edit: '修改',
    cancel: '取消',
    choiceUnit: '选择联网单位',
    passTips: '请输入密码',
    passTipsAgain: '请再次输入密码',
    passTwice: '两次输入密码不一致!',
    passTips615: '请输入8–15位字符,包含大小写字母、数字和特殊字符的三种以上',
    useTips: '该用户未绑定联网单位',
    all: '全部',
    allSearch: '(仅查询)',
    nameTips: '请输入关键字',
    clear: '清除',
    allTip: '请输入完整信息',
    usernameT: '请输入用户名',
    passT: '请输入密码',
    captchaT: '请输入验证码',
    indexofuserName: '新密码不能包含账号',
    samePass: '新密码不能与旧密码相同',
    forSecurity: '为安全起见，首次登录必须修改初始密码,确定关闭吗？',
    temporaryNotIOpen: '暂未开通'
  },
  disclaimer: {
    header: '使用条款和隐私政策',
    oneTitle: '一、总则',
    one: '您注册成为“火知眼”注册用户之前，应仔细阅读本服务协议。中消云（北京）物联网科技研究院有限公司（以下简称“中消云”）作为“火知眼”的经营者，根据本服务协议及/或随时对其的修改向您提供服务。如您不同意本服务协议、免责声明和隐私条款及/或随时对其的修改，您可以主动取消“火知眼”提供的服务。您一旦使用“火知眼”服务，即视为您已了解并完全同意本服务协议各项内容、免责声明和隐私条款，包括中消云对服务协议随时所做的任何修改，并成为“火知眼”注册用户（以下简称“用户”）。',
    oneOne: '1.1用户应当同意本协议的条款并按照页面上的提示完成全部的注册程序。注册该程序表示用户与火知眼达成协议，完全接受本协议项下的全部条款。',
    oneTwo: '1.2用户注册成功后，“火知眼”将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。',
    oneThree: '1.3用户可以使用“火知眼”各项服务，当用户使用“火知眼”各项服务时，用户的使用行为视为其对该项服务的服务条款以及“火知眼”在该项服务中发出的各类公告的同意。',
    oneFour: '1.4 “火知眼”服务协议以及各项服务条款和公告可由火知眼公司随时更新，且无需另行通知。您在使用相关服务时，应关注并遵守其所适用的相关条款。',
    twoTitle: '二、注册信息和隐私保护',
    two: '2.1 “火知眼”帐号（即“火知眼”用户ID）的所有权归火知眼，用户完成注册，获得“火知眼”帐号的使用权。',
    twoTwo: '2.2用户不得将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知“火知眼”。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，“火知眼”不承担任何责任。',
    twoThree: '2.3用户同意本公司记录并保存其登录和使用本服务中的相关信息，且同意本公司、关联公司及下属公司为保障用户使用本服务的安全以及不断改进服务质量的基础上使用该相关信息。但本公司承诺不将此类信息提供给任何第三方（除双方另有约定或法律法规另有规定及本公司关联公司外），但以下情况除外：',
    smallOne: '(1)事先获得用户的明确授权；',
    smallTwo: '(2)只有披露用户的个人资料，才能提供用户需要的产品和（或）服务；',
    smallThree: '(3)按照本协议的要求进行的披露；',
    smallFour: '(4)根据法律法规的规定；',
    smallFive: '(5)按照政府主管部门的要求；',
    smallSix: '(6)为维护本公司及其关联公司的合法权益。',
    twoFour: '2.4为了维护良好的用户关系，本公司会根据用户的身份数据进行综合统计，给予用户单纯获益型奖励（如用户生日赠送生日礼物或发送生日祝福等）。',
    threeTitle: '三、使用规则',
    threeOne: '3.1 用户在使用“火知眼”服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动。',
    threeTwo: '3.2 用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿“火知眼”与合作公司、关联公司，并使之免受损害。对此，“火知眼”有权视用户的行为性质，采取包括但不限于删除用户发布信息内容、暂停使用许可、终止服务、限制使用、回收“火知眼”帐号、追究法律责任等措施。对恶意注册“火知眼”帐号或利用“火知眼”帐号进行违法活动（如骚扰、欺骗、诈骗等），“火知眼”有权回收其帐号。同时，“火知眼”公司会依司法部门的要求，协助调查。',
    threeThree: '3.3 用户不得对本服务任何部分、通过本服务任何部分或使用本服务获得的任何内容，进行复制、拷贝、出售、转售或用于任何其它商业目的。',
    threeFour: '3.4 用户须对自己在使用“火知眼”服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在“火知眼”公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予“火知眼”公司等额的赔偿。',
    fourTitle: '四、服务内容',
    fourOne: '4.1 “火知眼”网络服务的具体内容由“火知眼”根据实际情况提供，“火知眼”对其提供之服务拥有最终解释权。',
    fourTwo: '4.2除非本服务协议另有其它明确规定，“火知眼”在用户注册后所推出的新产品、新功能、新服务，均受到本服务协议之规范。',
    fourThree: '4.3鉴于网络服务的特殊性，用户同意“火知眼”在该特殊情形下（如不可抗力或运营商平台原因、黑客攻击、网络瘫痪等非“火知眼”自身原因导致的情形）有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。“火知眼”不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。',
    fourFour: '4.4用户知悉， “火知眼”需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，并同意如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，“火知眼”无需为此承担任何责任。“火知眼”保留不经事先通知为维修保养、升级或其它目的暂停全部或部分的网络服务的权利。',
    fourFive: '4.5 “火知眼”有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，“火知眼”对用户和任何第三人均无需承担任何责任。',
    fourSix: '4.6终止服务 。您同意“火知眼”得基于其自行之考虑，因任何理由，包括但不限于长时间未使用，或“火知眼”认为您已经违反本服务协议，终止您的密码、帐号或本服务之使用（或服务之任何部分），并将您在本服务内任何内容加以移除并删除。您同意依本服务协议任何规定提供本服务，无需进行事先通知即可中断或终止，您承认并同意，“火知眼”可立即关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，您同意若本服务之使用被中断或终止或您的帐号及相关信息和文件被关闭或删除，“火知眼”对您或任何第三人均不承担任何责任。',
    fiveTitle: '五、免责声明',
    fiveOne: '5.1  “火知眼”作为一家互联网信息服务提供商，“火知眼”将火警监测设备信息汇集于互联网平台，并提供火警或故障的APP推送、电话拨打、以及发送短信的服务。',
    fiveTwo: '5.2 任何通过“火知眼”获取的场所以及设备信息均来自平台，“火知眼”负责按照自主创建（自建）、系统分配（系统）、以及他人分享（他人）分类，将数据分别传输到用户手中。但“火知眼”对火警信息仅提供对用户提供通知功能，不提供火警报警辅助，以及人员救助服务，用户需自行确认火警真实性，并通知火警“119”，并维护家人财产生命安全。',
    fiveThree: '5.3 “火知眼”不担保其提供的网络服务一定能满足您的要求，也不担保其提供的网络服务不会中断，对其提供的网络服务的及时性、安全性、准确性也都不做担保。',
    fiveFour: '5.4为方便您的使用，“火知眼”提供场所分享服务，用户需对其分享的联系人以及关注者的使用操作负责，由于联系人及关注者的误操作造成的损失，“火知眼”不承担任何责任。',
    fiveFive: '5.5 对于因不可抗力或“火知眼”不能控制的原因造成的网络服务中断或其他缺陷，“火知眼”不承担任何责任，但将尽力减少因此而给您造成的损失和影响。',
    fiveSix: '5.6 尽管“火知眼” 为方便您使用，会根据收到的您反馈信息在对服务进行调整，但是无法保证在接到反馈时第一时间做出调整，但您的反馈信息依旧是“火知眼”服务修改最重要的参考指标。',
    fiveSeven: '5.7 使用本服务是在基于使用“中消云”提供的火警监测网关以及设备的前提下，如果使用非本公司提供的网关或设备，“火知眼”无法为您提供服务。且由于网关及设备会留在用户的场所之中，请用户妥善保管好相应的网关及设备，且不擅自拆卸网关以及设备，若由于非网关以及设备自身原因导致的问题，“火知眼”不承担任何责任。',
    fiveEight: '5.8本声明适用中华人民共和国法律，您和“火知眼”一致同意服从中华人民共和国人民法院管辖。如其中任何条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款依旧具有法律效力。我们保留随时更改上述免责及其他条款的权利。',
    sixTitle: '六、其他',
    sixOne: '6.1本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。',
    sixTwo: '6.2如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向“火知眼”经营者所在地的人民法院提起诉讼。',
    sixThree: '6.3“火知眼”未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。',
    sixFour: '6.4如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。',
    sixFive: '6.5本《协议》的版权、解释权、修改权等均归“火知眼”经营者所有。',
    sixSix: '6.6您发现有违反“火知眼”相关协议等的行为（如任何违反本服务协议的本身行为、其他违反任何单项服务协议中的服务条款的行为、违反“火知眼”各类公告的行为等），请通知“火知眼”经营者中消云（北京）物联网科技研究院有限公司：',
    smallOneSix: '联系地址：北京市顺义区临空经济核心汇海南路1号院3号楼4层3-506',
    smallTwoSix: '联系电话：4000-220-119',
    // smallThreeSix: '电子邮件：',
    smallFourSix: '其他联系方式：010-65009696'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js